// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { useMutation } from "@tanstack/react-query";
// import { Eye, EyeOff } from "lucide-react";
// import logo from "../assets/img/logo.png";
// import loginimg from "../assets/img/loginimg.png";
// import { loginUser, forgotPassword } from "../api";

// export default function Login() {
//   const navigate = useNavigate();
//   const [step, setStep] = useState("signin");
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [resetEmail, setResetEmail] = useState("");
//   const [newPassword, setNewPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [resetError, setResetError] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const [showNewPass, setShowNewPass] = useState(false);
//   const [showConfirmPass, setShowConfirmPass] = useState(false);

//   const loginMutation = useMutation({
//     mutationFn: () => loginUser(email, password),
//     onSuccess: (data) => {
//       if (data.user) localStorage.setItem("user", JSON.stringify(data.user));
//       if (data.token) localStorage.setItem("token", data.token);
//      const role = data.user?.role?.toLowerCase();
//    //   navigate(role === "super admin" ? "/dashboard-overview" : "/employee");
//     if (role === "super admin") {
//       navigate("/dashboard-overview");
//     } else if (role === "developer") {
//       navigate("/supportticket");
//     } else {
//       navigate("/employee");
//     }
//     },
//   });

//   const forgotMutation = useMutation({
//     mutationFn: () => forgotPassword(resetEmail),
//     onSuccess: () => setStep("reset"),
//   });

//   const handleSignIn = (e) => { e.preventDefault(); loginMutation.mutate(); };
//   const handleForgot = (e) => { e.preventDefault(); forgotMutation.mutate(); };
//   const handleReset = (e) => {
//     e.preventDefault();
//     if (newPassword !== confirmPassword) { setResetError("Passwords do not match"); return; }
//     setResetError("");
//     setStep("signin");
//   };

//   return (
//     <div style={styles.wrapper}>
//       <div style={styles.left}>
//         <img src={logo} alt="logo" style={styles.logo} />
//         <div style={styles.formBox}>

//           {step === "signin" && (
//             <>
//               <h2 style={styles.title}>Sign In</h2>
//               <p style={styles.sub}>Welcome back to your account. Log in to manage your dashboard</p>
//               {loginMutation.isError && <div style={styles.errorMsg}>{loginMutation.error.message}</div>}
//               <form onSubmit={handleSignIn} style={styles.form}>
//                 <div style={styles.fieldGroup}>
//                   <label style={styles.label}>Email</label>
//                   <input style={styles.input} type="email" placeholder="Enter your email" value={email} onChange={(e) => setEmail(e.target.value)} required />
//                 </div>
//                 <div style={styles.fieldGroup}>
//                   <label style={styles.label}>Password</label>
//                   <div style={styles.inputWrap}>
//                     <input style={styles.input} type={showPassword ? "text" : "password"} placeholder="Enter your password" value={password} onChange={(e) => setPassword(e.target.value)} required />
//                     <span style={styles.eyeIcon} onClick={() => setShowPassword(!showPassword)}>
//                       {showPassword ? <Eye size={16} /> : <EyeOff size={16} />}
//                     </span>
//                   </div>
//                 </div>
//                 <div style={styles.forgotRow}>
//                   <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, color: "#475569", cursor: "pointer" }}>
//                     <input type="checkbox" style={{ cursor: "pointer" }} /> Keep me logged in
//                   </label>
//                   <span style={styles.forgotLink} onClick={() => setStep("forgot")}>Forgot password?</span>
//                 </div>
//                 <button style={styles.btn} type="submit" disabled={loginMutation.isPending}>
//                   {loginMutation.isPending ? "Signing in..." : "Sign In"}
//                 </button>
//               </form>
//             </>
//           )}

//           {step === "forgot" && (
//             <>
//               <h2 style={styles.title}>Forgot Password?</h2>
//               <p style={styles.sub}>Enter your email and we'll send you a link to reset your password.</p>
//               {forgotMutation.isError && <div style={styles.errorMsg}>{forgotMutation.error.message}</div>}
//               {forgotMutation.isSuccess && <div style={styles.successMsg}>Reset link sent! Check your email.</div>}
//               <form onSubmit={handleForgot} style={styles.form}>
//                 <div style={styles.fieldGroup}>
//                   <label style={styles.label}>Email</label>
//                   <input style={styles.input} type="email" placeholder="Enter your email" value={resetEmail} onChange={(e) => setResetEmail(e.target.value)} required />
//                 </div>
//                 <button style={styles.btn} type="submit" disabled={forgotMutation.isPending}>
//                   {forgotMutation.isPending ? "Sending..." : "Send Reset Link"}
//                 </button>
//                 <p style={styles.backRow}><span style={styles.forgotLink} onClick={() => setStep("signin")}>← Back to Sign In</span></p>
//               </form>
//             </>
//           )}

//           {step === "reset" && (
//             <>
//               <h2 style={styles.title}>Reset Password</h2>
//               <p style={styles.sub}>Reset your password to secure your account.</p>
//               {resetError && <div style={styles.errorMsg}>{resetError}</div>}
//               <form onSubmit={handleReset} style={styles.form}>
//                 <div style={styles.fieldGroup}>
//                   <label style={styles.label}>New Password</label>
//                   <div style={styles.inputWrap}>
//                     <input style={styles.input} type={showNewPass ? "text" : "password"} placeholder="Enter new password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required />
//                     <span style={styles.eyeIcon} onClick={() => setShowNewPass(!showNewPass)}>
//                       {showNewPass ? <Eye size={16} /> : <EyeOff size={16} />}
//                     </span>
//                   </div>
//                 </div>
//                 <div style={styles.fieldGroup}>
//                   <label style={styles.label}>Confirm Password</label>
//                   <div style={styles.inputWrap}>
//                     <input style={styles.input} type={showConfirmPass ? "text" : "password"} placeholder="Confirm new password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
//                     <span style={styles.eyeIcon} onClick={() => setShowConfirmPass(!showConfirmPass)}>
//                       {showConfirmPass ? <Eye size={16} /> : <EyeOff size={16} />}
//                     </span>
//                   </div>
//                 </div>
//                 <button style={styles.btn} type="submit">Update Password</button>
//                 <p style={styles.backRow}><span style={styles.forgotLink} onClick={() => setStep("signin")}>← Back to Sign In</span></p>
//               </form>
//             </>
//           )}

//         </div>
//       </div>

//       <div style={styles.right}>
//         <img src={loginimg} alt="login visual" style={styles.loginImg} />
//       </div>
//     </div>
//   );
// }

// const styles = {
//   wrapper: { display: "flex", height: "100vh", fontFamily: "'Segoe UI', sans-serif", overflow: "hidden" },
//   left: { flex: 1, display: "flex", flexDirection: "column", padding: "40px 60px", paddingLeft: "150px", background: "#fff", justifyContent: "center", marginLeft: 80 },
//   logo: { width: 140, objectFit: "contain", marginBottom: 40, marginLeft: 80 },
//   formBox: { maxWidth: 400 },
//   title: { fontSize: 26, fontWeight: 700, color: "#080e21", marginBottom: 6 },
//   sub: { fontSize: 14, color: "#64748b", marginBottom: 24 },
//   form: { display: "flex", flexDirection: "column", gap: 16 },
//   fieldGroup: { display: "flex", flexDirection: "column", gap: 6 },
//   label: { fontSize: 13, fontWeight: 600, color: "#1e293b" },
//   inputWrap: { position: "relative", display: "flex", alignItems: "center" },

//   input: { padding: "10px 14px", paddingRight: 40, borderRadius: 8, border: "1px solid #e2e8f0", fontSize: 14, outline: "none", width: "100%", boxSizing: "border-box" },
//   eyeIcon: { position: "absolute", right: 12, cursor: "pointer", color: "#94a3b8", display: "flex" },
//   forgotRow: { display: "flex", justifyContent: "space-between", alignItems: "center" },
//   forgotLink: { fontSize: 13, color: "#211b08", cursor: "pointer", fontWeight: 500 },
//   btn: { padding: "11px", background: "#080e21", color: "#fff", border: "none", borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: "pointer", marginTop: 4 },
//   backRow: { textAlign: "center", marginTop: 4 },
//   errorMsg: { background: "#fee2e2", color: "#dc2626", padding: "8px 12px", borderRadius: 6, fontSize: 13, marginBottom: 12 },
//   successMsg: { background: "#dcfce7", color: "#16a34a", padding: "8px 12px", borderRadius: 6, fontSize: 13, marginBottom: 12 },
//   right: { flex: 1, background: "#fff", display: "flex", alignItems: "center", justifyContent: "flex-end", overflow: "hidden", paddingRight: 30 },
//   loginImg: { width: "110%", height: "95%", objectFit: "cover", borderRadius: "15px" },
// };

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { Eye, EyeOff } from "lucide-react";
import logo from "../assets/img/logo.png";
import loginimg from "../assets/img/loginimg.png";
import { loginUser, forgotPassword } from "../api";

export default function Login() {
  const navigate = useNavigate();

  const [step, setStep] = useState("signin");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [resetEmail, setResetEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [resetError, setResetError] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [showNewPass, setShowNewPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);

  // Login mutation
  const loginMutation = useMutation({
    mutationFn: () => loginUser(email, password),

    onSuccess: (data) => {
      if (data.user) {
        localStorage.setItem("user", JSON.stringify(data.user));
      }

      if (data.token) {
        localStorage.setItem("token", data.token);
      }

      const role = data.user?.role?.toLowerCase();

      if (role === "super admin") {
        navigate("/dashboard-overview");
      } else if (role === "developer") {
        navigate("/supportticket");
      } else {
        navigate("/employee");
      }
    },
  });

  // Forgot password mutation
  const forgotMutation = useMutation({
    mutationFn: () => forgotPassword(resetEmail),

    onSuccess: () => {
      setStep("reset");
    },
  });

  // Sign in
  const handleSignIn = (e) => {
    e.preventDefault();
    loginMutation.mutate();
  };

  // Forgot password
  const handleForgot = (e) => {
    e.preventDefault();
    forgotMutation.mutate();
  };

  // Reset password
  const handleReset = (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setResetError("Passwords do not match");
      return;
    }

    setResetError("");
    setStep("signin");
  };

  return (
    <>
      <style>{`
        * {
          box-sizing: border-box;
        }

        .login-wrapper {
          display: flex;
          min-height: 100vh;
          width: 100%;
          font-family: "Segoe UI", sans-serif;
          background: #ffffff;
          overflow: hidden;
        }

      .login-left {
  flex: 1 1 50%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 60px;
  background: #ffffff;
}
.login-form-box {
  width: 100%;
  max-width: 400px;
}

.login-logo {
  width: 140px;
  max-width: 100%;
  height: auto;
  object-fit: contain;
  margin-bottom: 40px;
}

        .login-title {
          font-size: 26px;
          font-weight: 700;
          color: #080e21;
          margin: 0 0 6px;
        }

        .login-sub {
          font-size: 14px;
          line-height: 1.6;
          color: #64748b;
          margin: 0 0 24px;
        }

        .login-form {
          display: flex;
          flex-direction: column;
          gap: 16px;
          width: 100%;
        }

        .login-field-group {
          display: flex;
          flex-direction: column;
          gap: 6px;
          width: 100%;
        }

        .login-label {
          font-size: 13px;
          font-weight: 600;
          color: #1e293b;
        }

        .login-input-wrap {
          position: relative;
          display: flex;
          align-items: center;
          width: 100%;
        }

        .login-input {
          padding: 12px 14px;
          padding-right: 42px;
          border-radius: 8px;
          border: 1px solid #e2e8f0;
          font-size: 14px;
          outline: none;
          width: 100%;
          min-width: 0;
          background: #ffffff;
          color: #1e293b;
        }

        .login-input:focus {
          border-color: #080e21;
          box-shadow: 0 0 0 2px rgba(8, 14, 33, 0.08);
        }

        .login-input::placeholder {
          color: #94a3b8;
        }

        .login-eye-icon {
          position: absolute;
          right: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 5px;
          border: none;
          background: transparent;
          color: #94a3b8;
          cursor: pointer;
        }

        .login-eye-icon:hover {
          color: #080e21;
        }

        .login-forgot-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 12px;
          flex-wrap: wrap;
        }

        .login-remember {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 13px;
          color: #475569;
          cursor: pointer;
        }

        .login-remember input {
          cursor: pointer;
        }

        .login-forgot-link {
          font-size: 13px;
          color: #211b08;
          cursor: pointer;
          font-weight: 500;
        }

        .login-forgot-link:hover {
          text-decoration: underline;
        }

        .login-btn {
          padding: 12px;
          background: #080e21;
          color: #ffffff;
          border: none;
          border-radius: 8px;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
          margin-top: 4px;
          width: 100%;
          transition: opacity 0.2s ease;
        }

        .login-btn:hover {
          opacity: 0.9;
        }

        .login-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .login-back-row {
          text-align: center;
          margin: 4px 0 0;
        }

        .login-error-msg {
          background: #fee2e2;
          color: #dc2626;
          padding: 8px 12px;
          border-radius: 6px;
          font-size: 13px;
          margin-bottom: 12px;
          overflow-wrap: anywhere;
        }

        .login-success-msg {
          background: #dcfce7;
          color: #16a34a;
          padding: 8px 12px;
          border-radius: 6px;
          font-size: 13px;
          margin-bottom: 12px;
          overflow-wrap: anywhere;
        }

        .login-right {
          flex: 1 1 50%;
          min-width: 0;
          background: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          padding: 24px;
        }

        .login-image {
          display: block;
          width: 100%;
          max-width: 650px;
          height: auto;
          max-height: calc(100vh - 48px);
          object-fit: contain;
          border-radius: 15px;
        }

        /* Tablet */
        @media (max-width: 1024px) {
          .login-left {
            padding: 32px;
          }

          .login-right {
            padding: 20px;
          }

          .login-logo {
            margin-bottom: 32px;
          }
        }

        /* Mobile */
        @media (max-width: 768px) {
          .login-wrapper {
            min-height: 100vh;
            overflow-y: auto;
          }

          .login-left {
            flex: 1 1 100%;
            width: 100%;
            min-height: 100vh;
            padding: 32px 24px;
            align-items: center;
          }

          .login-form-box {
            width: 100%;
            max-width: 450px;
          }

          .login-right {
            display: none;
          }

          .login-logo {
            width: 130px;
            margin-bottom: 32px;
          }
        }

        /* Small mobile */
        @media (max-width: 480px) {
          .login-left {
            padding: 24px 20px;
          }

          .login-logo {
            width: 120px;
            margin-bottom: 28px;
          }

          .login-title {
            font-size: 24px;
          }

          .login-sub {
            font-size: 13px;
            margin-bottom: 20px;
          }

          .login-form {
            gap: 14px;
          }

          .login-input {
            padding: 11px 12px;
            padding-right: 40px;
          }

          .login-forgot-row {
            align-items: flex-start;
          }

          .login-btn {
            padding: 12px;
          }
        }

        /* Very small devices */
        @media (max-width: 360px) {
          .login-left {
            padding: 24px 16px;
          }

          .login-title {
            font-size: 22px;
          }

          .login-forgot-row {
            flex-direction: column;
            align-items: flex-start;
          }
        }
      `}</style>

      <div className="login-wrapper">
        {/* Left side - Form */}
        <div className="login-left">
          <img src={logo} alt="Verisaya logo" className="login-logo" />

          <div className="login-form-box">
            {/* Sign In */}
            {step === "signin" && (
              <>
                <h2 className="login-title">Sign In</h2>

                <p className="login-sub">
                  Welcome back to your account. Log in to manage your dashboard
                </p>

                {loginMutation.isError && (
                  <div className="login-error-msg">
                    {loginMutation.error?.message ||
                      "Login failed. Please try again."}
                  </div>
                )}

                <form onSubmit={handleSignIn} className="login-form">
                  <div className="login-field-group">
                    <label className="login-label">Email</label>

                    <input
                      className="login-input"
                      type="email"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>

                  <div className="login-field-group">
                    <label className="login-label">Password</label>

                    <div className="login-input-wrap">
                      <input
                        className="login-input"
                        type={showPassword ? "text" : "password"}
                        placeholder="Enter your password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />

                      <button
                        type="button"
                        className="login-eye-icon"
                        aria-label={
                          showPassword ? "Hide password" : "Show password"
                        }
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? (
                          <Eye size={16} />
                        ) : (
                          <EyeOff size={16} />
                        )}
                      </button>
                    </div>
                  </div>

                  <div className="login-forgot-row">
                    <label className="login-remember">
                      <input type="checkbox" />
                      Keep me logged in
                    </label>

                    <span
                      className="login-forgot-link"
                      onClick={() => setStep("forgot")}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          setStep("forgot");
                        }
                      }}
                    >
                      Forgot password?
                    </span>
                  </div>

                  <button
                    className="login-btn"
                    type="submit"
                    disabled={loginMutation.isPending}
                  >
                    {loginMutation.isPending ? "Signing in..." : "Sign In"}
                  </button>
                </form>
              </>
            )}

            {/* Forgot Password */}
            {step === "forgot" && (
              <>
                <h2 className="login-title">Forgot Password?</h2>

                <p className="login-sub">
                  Enter your email and we'll send you a link to reset your
                  password.
                </p>

                {forgotMutation.isError && (
                  <div className="login-error-msg">
                    {forgotMutation.error?.message ||
                      "Unable to send reset link."}
                  </div>
                )}

                {forgotMutation.isSuccess && (
                  <div className="login-success-msg">
                    Reset link sent! Check your email.
                  </div>
                )}

                <form onSubmit={handleForgot} className="login-form">
                  <div className="login-field-group">
                    <label className="login-label">Email</label>

                    <input
                      className="login-input"
                      type="email"
                      placeholder="Enter your email"
                      value={resetEmail}
                      onChange={(e) => setResetEmail(e.target.value)}
                      required
                    />
                  </div>

                  <button
                    className="login-btn"
                    type="submit"
                    disabled={forgotMutation.isPending}
                  >
                    {forgotMutation.isPending
                      ? "Sending..."
                      : "Send Reset Link"}
                  </button>

                  <p className="login-back-row">
                    <span
                      className="login-forgot-link"
                      onClick={() => setStep("signin")}
                      role="button"
                      tabIndex={0}
                    >
                      ← Back to Sign In
                    </span>
                  </p>
                </form>
              </>
            )}

            {/* Reset Password */}
            {step === "reset" && (
              <>
                <h2 className="login-title">Reset Password</h2>

                <p className="login-sub">
                  Reset your password to secure your account.
                </p>

                {resetError && (
                  <div className="login-error-msg">{resetError}</div>
                )}

                <form onSubmit={handleReset} className="login-form">
                  <div className="login-field-group">
                    <label className="login-label">New Password</label>

                    <div className="login-input-wrap">
                      <input
                        className="login-input"
                        type={showNewPass ? "text" : "password"}
                        placeholder="Enter new password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                      />

                      <button
                        type="button"
                        className="login-eye-icon"
                        aria-label={
                          showNewPass
                            ? "Hide new password"
                            : "Show new password"
                        }
                        onClick={() => setShowNewPass(!showNewPass)}
                      >
                        {showNewPass ? <Eye size={16} /> : <EyeOff size={16} />}
                      </button>
                    </div>
                  </div>

                  <div className="login-field-group">
                    <label className="login-label">Confirm Password</label>

                    <div className="login-input-wrap">
                      <input
                        className="login-input"
                        type={showConfirmPass ? "text" : "password"}
                        placeholder="Confirm new password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                      />

                      <button
                        type="button"
                        className="login-eye-icon"
                        aria-label={
                          showConfirmPass
                            ? "Hide confirm password"
                            : "Show confirm password"
                        }
                        onClick={() => setShowConfirmPass(!showConfirmPass)}
                      >
                        {showConfirmPass ? (
                          <Eye size={16} />
                        ) : (
                          <EyeOff size={16} />
                        )}
                      </button>
                    </div>
                  </div>

                  <button className="login-btn" type="submit">
                    Update Password
                  </button>

                  <p className="login-back-row">
                    <span
                      className="login-forgot-link"
                      onClick={() => setStep("signin")}
                      role="button"
                      tabIndex={0}
                    >
                      ← Back to Sign In
                    </span>
                  </p>
                </form>
              </>
            )}
          </div>
        </div>

        {/* Right side - Image */}
        <div className="login-right">
          <img
            src={loginimg}
            alt="Login illustration"
            className="login-image"
          />
        </div>
      </div>
    </>
  );
}
